<!-- Update main-layout.component.html -->
<div class="main-layout">
  <div
    class="sidebar-backdrop"
    *ngIf="isSidebarOpen && isMobile"
    (click)="closeSidebar()"
  ></div>

  <div class="content-wrapper" [class.sidebar-open]="isSidebarOpen && isMobile">
    <app-sidebar
      class="sidebar"
      [isOpen]="isSidebarOpen"
      (toggle)="toggleSidebar()"
    ></app-sidebar>
    <div class="main-container">
      <app-header
        [searchValue]="currentSearchValue"
        (searchChanged)="onSearch($event)"
        (toggleSidebar)="toggleSidebar()"
      ></app-header>
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
  
  <!-- Add landscape alert component -->
  <app-landscape-alert></app-landscape-alert>
</div>